document.documentElement.classList.add('js');
addEventListener('DOMContentLoaded', function () {
  var ua = navigator.userAgent || '';
  var storeUrl = /Android/i.test(ua)
    ? 'https://play.google.com/store/apps/details?id=com.hq.festivehwapp'
    : (/iPhone|iPad|iPod/i.test(ua) && !window.MSStream)
      ? 'https://apps.apple.com/in/app/festive-reader/id6753059563'
      : null;
  if (storeUrl) {
    document.querySelectorAll('[data-store-link]').forEach(function (el) {
      el.setAttribute('href', storeUrl);
    });
  }

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: .12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  var toggle = document.querySelector('.nav-toggle');
  var nav = document.getElementById('site-nav');
  if (toggle && nav) {
    var closeMenu = function () {
      nav.classList.remove('open');
      toggle.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
    };
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('open');
      toggle.classList.toggle('open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
    addEventListener('resize', function () {
      if (innerWidth > 900) closeMenu();
    });
  }
});
